// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__j_FN-","spacer":"Header_spacer__21LIP","navContainer":"Header_navContainer__3iet_","navLink":"Header_navLink__1v0bo","logo":"Header_logo__2KLTQ"};